import { useAuthors } from '@/hooks/useAuthors';

interface AuthorSelectProps {
  value: string;
  onChange: (author: string) => void;
}

export function AuthorSelect({ value, onChange }: AuthorSelectProps) {
  const { authors, loading } = useAuthors();

  return (
    <div className="filter-group mb-4">
      <label htmlFor="authorSelect" className="block text-text-secondary text-xs font-semibold mb-2">
        作者筛选
      </label>
      <select
        id="authorSelect"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={loading}
        className="w-full px-3 py-2.5 bg-bg-tertiary border border-border rounded-lg text-text-primary text-sm focus:outline-none focus:border-accent disabled:opacity-50"
      >
        <option value="">全部作者</option>
        {authors.map((author) => (
          <option key={author.screen_name} value={author.screen_name}>
            {author.user_name} (@{author.screen_name}) - {author.tweet_count}
          </option>
        ))}
      </select>
    </div>
  );
}
